import { xDivide } from 'ml-spectra-processing';
export function rescaleAndEnsureInteger(data, factor) {
    if (factor === 1)
        return data.map((value) => Math.round(value));
    return xDivide(data, factor);
}
//# sourceMappingURL=rescaleAndEnsureInteger.js.map